// extracted by mini-css-extract-plugin
export var card = "InnerCta-module--card--f6e17";
export var description = "InnerCta-module--description--cbdb9";
export var image = "InnerCta-module--image--55d0a";